import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFindMemeberIdApi, usePostSendEmailVerificationApi, usePostVerifyCodeApi } from '@/api/auth';
import Field from '@/components/common/Field/Field';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import InputText from '@/components/common/Input/InputText/InputText';
import { emailOptions } from '@/constants/option';
import { useModalStore } from '@/store/modalStore';

import * as S from './style';

const FindId = () => {
	const navigate = useNavigate();
	const { showModal } = useModalStore();
	const [name, setName] = useState('');
	const [email, setEmail] = useState({ front: '', back: '', code: '직접입력', verificationCode: '' });
	const [isEmailVerified, setIsEmailVerified] = useState(false);
	const [isSendEmail, setIsSendEmail] = useState(false);
	const { mutateAsync: VerifyCode } = usePostVerifyCodeApi();
	const { mutateAsync: SendEmailVerification, isPending } = usePostSendEmailVerificationApi();
	const { mutateAsync: findMemberId } = useFindMemeberIdApi();
	const handleSendEmailVerification = async () => {
		const res = await SendEmailVerification({ email: `${email.front}@${email.back}` });
		if (res.data.success) {
			showModal('입력하신 이메일로 인증번호가 발송되었습니다.\n이메일을 확인하신 후 인증번호를 입력해 주세요.');
		}
		setIsSendEmail(true);
	};
	const handleVerifyCode = async () => {
		const emailResult = `${email.front}@${email.back}`;
		const res = await VerifyCode({ email: emailResult, code: email.verificationCode });
		if (res.data.success) {
			showModal('인증이 완료되었습니다.');
			setIsEmailVerified(true);
		} else {
			showModal('인증번호가 일치하지 않습니다.');
			setIsEmailVerified(false);
		}
	};
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const res = await findMemberId({ member_name: name, member_email: `${email.front}@${email.back}` });
		if (res.data.success) {
			if (res.data.data.member_id !== null) {
				navigate('/auth/findid/complete', {
					state: {
						member_id: res.data.data.member_id,
					},
				});
			} else {
				showModal('해당하는 회원이 없습니다.');
			}
		}
	};

	return (
		<main>
			<S.Container onSubmit={onSubmit}>
				<div className="title">아이디 찾기</div>
				<S.FieldBox>
					<Field title="이름" error="">
						<InputText
							placeholder="이름입력"
							value={name}
							input={(e: React.ChangeEvent<HTMLInputElement>) => {
								setName(e.target.value);
							}}
						/>
					</Field>
					<Field title="이메일 인증" gap="0.8rem">
						<Field>
							<S.FlexRow>
								<InputText
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, front: e.target.value }));
										setIsSendEmail(false);
									}}
									value={email.front}
								/>
								@
								<InputText
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, back: e.target.value }));
										setIsSendEmail(false);
									}}
									value={email.code !== '' && email.code !== '직접입력' ? email.code : email.back}
									readonly={email.code !== '' && email.code !== '직접입력'}
								/>
								<InputSelect
									options={emailOptions}
									selectedOption={email.code}
									setSelectedOption={(val) => {
										setEmail((prev) => ({ ...prev, code: val }));

										if (val !== '직접입력') {
											setEmail((prev) => ({ ...prev, back: val }));
											setIsSendEmail(false);
										}
									}}
									defaultValue="직접입력"
								/>
								<S.FindButton
									type="button"
									onClick={handleSendEmailVerification}
									disabled={email.front === '' || email.back === '' || email.code === '' || isPending}
								>
									{!isSendEmail ? '전송' : '재전송'}
								</S.FindButton>
							</S.FlexRow>
							<S.FlexRow>
								<InputText
									value={email.verificationCode}
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, verificationCode: e.target.value }));
										setIsEmailVerified(false);
									}}
									placeholder="인증번호 입력"
								/>
								<S.FindButton type="button" onClick={handleVerifyCode} disabled={email.verificationCode === '' || isEmailVerified}>
									인증
								</S.FindButton>
							</S.FlexRow>
							<S.Danger>※ 이메일 인증의 경우 받는 메일서버에 따라 도착이 지연되거나 스팸으로 분류될 수 있습니다.</S.Danger>
						</Field>
					</Field>
					<S.Button
						disabled={name === '' || email.front === '' || email.back === '' || email.code === '' || email.verificationCode === '' || !isEmailVerified}
						type="submit"
					>
						아이디 찾기
					</S.Button>
				</S.FieldBox>
			</S.Container>
		</main>
	);
};

export default FindId;
